import React, { useState, useEffect, useRef } from "react";
import { CompanyPrefrenceForm } from "../forms/CustomerAdmin/CompanyPrefrence";
import { SubscriptionForm } from "../forms/CustomerAdmin/SubscriptionForm";
import { CompanyDetailForm } from "../forms/CustomerAdmin/CompanyDetailForm";
import { AdminUSerForm } from "../forms/CustomerAdmin/AdminUSerForm";
import { userSession } from "../../observers/userObserver";
import config from "../config";
const CompanySettingsPanel = ({
    
  handleChange,
}) => {
     const handleCompanyChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  }
    const [isEditing, setIsEditing] = useState(false);
    const [formData, setFormData] = useState({
        URL: '',
        PrimaryColor: '',
        SecondaryColor: '',
        TertiaryColor: '',
        SubscriptionPlan: '',
        SubscriptionRenew: '',
        CompanyName: '',
        Address1: '',
        Address2: '',
        Address3: '',
        State: '',
        Country: '',
        Username: '',
        EmailAddress: '',
        email: '',
        userName: '',
        password: ''
      });
       const fetchDashboardData = async () => {
    try {
      const token = userSession.getToken();

      const response = await fetch(`${config["backend-url"]}/admin_dashboard_data`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (response.ok) {
        console.log("✅ Dashboard data loaded:", data);
        

        setFormData({
          URL: data.company.LogoURL || '',
          PrimaryColor: data.company.PrimaryColor || '',
          SecondaryColor: data.company.SecondaryColor || '',
          TertiaryColor: data.company.TertiaryColor || '',
          SubscriptionPlan: 'Yearly', // ✅ Hardcoded
          SubscriptionRenew: data.company.SubscriptionRenew || '',
          CompanyName: data.company.CompanyName || '',
          Address1: data.company.Address1 || '',
          Address2: data.company.Address2 || '',
          Address3: data.company.Address3 || '',
          State: data.company.State || '',
          Country: data.company.Country || '',
          Username: data.AdminUser.name || '',
          EmailAddress: data.AdminUser.email || '',
        });

        
      } else {
        console.error("❌ Failed to load:", data.error);
      }
    } catch (error) {
      console.error("❌ Network or server error:", error);
    }
  };
   useEffect(() => {
      fetchDashboardData();
    }, []);
      const handleToggleEdit = () => {
    if (isEditing) {
 
      console.log("Saving", formData);
    }
    setIsEditing(!isEditing);
  };
   const handleSaveCompanyPreferences = async () => {
    try {
      const token = userSession.getToken();

      const response = await fetch(`${config["backend-url"]}/save_company_preferences`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formData),  // send the updated formData
      });

      const result = await response.json();

      if (response.ok) {
        console.log("✅ Company preferences updated successfully:", result.message);
        setIsEditing(false); // exit edit mode
      } else {
        console.error("❌ Failed to update:", result.error);
      }
    } catch (error) {
      console.error("❌ Network or server error:", error);
    }
  };
  return (
    <div className="recent-requests">
      <div style={{ width: "100%", display: "flex", gap: "10px" }}>
        {/* Company Preferences */}
        <div className="comprefrence">
          <div className="dashboard-header">
            <h4 className="welcomeText">Company Preferences</h4>
            <button
              className="add-request"
              onClick={isEditing ? handleSaveCompanyPreferences : handleToggleEdit}
            >
              {isEditing ? "Save Company Preferences" : "Edit Company Preferences"}
            </button>
          </div>
          <CompanyPrefrenceForm
            formData={formData}
            handleCompanyChange={handleCompanyChange}
            isEditing={isEditing}
          />
        </div>

        {/* Subscription Plan */}
        <div className="comprefrence">
          <div className="dashboard-header">
            <h4 className="welcomeText">Subscription Plan</h4>
            <span>*Contact COD to Modify</span>
          </div>
          <SubscriptionForm
            formData={formData}
            handleChange={handleChange}
          />
        </div>
      </div>

      {/* Company Details */}
      <div className="comprefrence">
        <div className="dashboard-header">
          <h4 className="welcomeText">Company Details</h4>
          <span>*Contact COD to Modify</span>
        </div>
        <CompanyDetailForm formData={formData} />
      </div>

      {/* Admin User */}
      <div className="comprefrence">
        <div className="dashboard-header">
          <h4 className="welcomeText">Admin User</h4>
        </div>
        <AdminUSerForm formData={formData} />
      </div>
    </div>
  );
};

export default CompanySettingsPanel;
